import { Box, SxProps } from "@mui/system";
import { PropsWithChildren } from "react";
import { colorBorder, colorSurface, radiusInner } from "./tokens";

export type CardProps = {
    sx?: SxProps
} & PropsWithChildren

export const Card = ({ children, sx = {} }: CardProps) => (
    <Box
        sx={{
            display: "flex",
            gap: 1.5,
            flexWrap: "wrap",
            borderRadius: radiusInner,
            padding: 2,
            backgroundColor: colorSurface,
            borderStyle: "solid",
            borderColor: colorBorder,
            borderWidth: 1,
            ...sx,
        }}
    >
        {children}
    </Box>
)